import { useEffect, useState } from "react";
import { crm } from "../lib/crmClient";

export default function CrmClients() {
    const [clients, setClients] = useState([]);
    const [form, setForm] = useState({ name: "", email: "", phone: "", address: "", notes: "" });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const load = () => {
        crm.get("/crm/clients")
            .then((r) => setClients(r.data))
            .finally(() => setLoading(false));
    };
    useEffect(load, []);

    const create = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const payload = { ...form };
            if (!payload.email) delete payload.email;
            await crm.post("/crm/clients", payload);
            setForm({ name: "", email: "", phone: "", address: "", notes: "" });
            load();
        } finally {
            setSaving(false);
        }
    };

    const remove = async (id) => {
        if (!window.confirm("Delete this client?")) return;
        await crm.delete(`/crm/clients/${id}`);
        load();
    };

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    return (
        <div data-testid="crm-clients">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50">[ Clients ]</div>
            <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tight mt-2">Client roster.</h1>

            <form onSubmit={create} className="mt-10 glass border border-white/15 p-6 grid grid-cols-1 md:grid-cols-6 gap-3">
                <input required data-testid="client-name" placeholder="Name *" value={form.name} onChange={set("name")}
                    className="md:col-span-2 bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-3 py-2.5 font-mono text-[13px] text-white placeholder-white/30"/>
                <input data-testid="client-email" placeholder="Email" value={form.email} onChange={set("email")} type="email"
                    className="md:col-span-2 bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-3 py-2.5 font-mono text-[13px] text-white placeholder-white/30"/>
                <input data-testid="client-phone" placeholder="Phone" value={form.phone} onChange={set("phone")}
                    className="md:col-span-2 bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-3 py-2.5 font-mono text-[13px] text-white placeholder-white/30"/>
                <input data-testid="client-address" placeholder="Address" value={form.address} onChange={set("address")}
                    className="md:col-span-4 bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-3 py-2.5 font-mono text-[13px] text-white placeholder-white/30"/>
                <button data-testid="client-add" type="submit" disabled={saving}
                    className="md:col-span-2 border border-[#FFE600] text-[#FFE600] hover:bg-[#FFE600] hover:text-black transition-colors px-4 py-2.5 font-mono text-[11px] tracking-[0.28em] uppercase disabled:opacity-50">
                    {saving ? "Adding…" : "+ Add Client"}
                </button>
            </form>

            <div className="mt-8 border border-white/10">
                {loading ? (
                    <div className="p-8 font-mono text-[11px] tracking-[0.28em] uppercase text-white/40">Loading…</div>
                ) : clients.length === 0 ? (
                    <div data-testid="clients-empty" className="p-10 text-center font-mono text-[11px] tracking-[0.28em] uppercase text-white/40">
                        No clients yet — add your first above
                    </div>
                ) : (
                    <table className="w-full">
                        <thead>
                            <tr className="text-left border-b border-white/10">
                                {["Name","Email","Phone","Address",""].map((h) => (
                                    <th key={h} className="p-4 font-mono text-[9px] tracking-[0.28em] uppercase text-white/40">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {clients.map((c) => (
                                <tr key={c.id} data-testid={`client-row-${c.id}`} className="border-b border-white/5 hover:bg-white/[0.03]">
                                    <td className="p-4 font-display uppercase text-lg">{c.name}</td>
                                    <td className="p-4 font-mono text-[12px] text-white/70">{c.email || "—"}</td>
                                    <td className="p-4 font-mono text-[12px] text-white/70">{c.phone || "—"}</td>
                                    <td className="p-4 font-mono text-[12px] text-white/70">{c.address || "—"}</td>
                                    <td className="p-4 text-right">
                                        <button onClick={() => remove(c.id)}
                                            className="font-mono text-[10px] tracking-[0.28em] uppercase text-red-400 hover:text-red-300">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
